import { render, staticRenderFns } from "./ContentNavigationItem.vue?vue&type=template&id=49679fd7"
import script from "./ContentNavigationItem.vue?vue&type=script&lang=ts"
export * from "./ContentNavigationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports